export default __webpack_public_path__ + "static/media/id-card.31eef8d0.png";